"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfigurationSpace = exports.SpaceId = exports.TemplateWithId = exports.Template = exports.ParticleProperties = exports.MatchRules = exports.PrologRuleReference = exports.PrologRuleBody = exports.PrologRuleId = exports.Configuration = exports.Structure = exports.Part = exports.Cursor = exports.PropertyOptions = exports.FilterMode = exports.PropertySelections = exports.PropertyValue = exports.PropertyName = exports.PartName = exports.TemplateId = exports.ProductSpaces = exports.ProductId = exports.ParticleId = exports.TenantId = void 0;
const effect_1 = require("effect");
// NOTE: Only including brands for the types which are 'owned' by gavel
exports.TenantId = effect_1.Schema.String;
exports.ParticleId = effect_1.Schema.String;
exports.ProductId = effect_1.Schema.String;
exports.ProductSpaces = effect_1.Schema.Array(effect_1.Schema.String);
exports.TemplateId = effect_1.Schema.String.pipe(effect_1.Schema.brand('@fixtuur/gavel/TemplateId'));
exports.PartName = effect_1.Schema.String.pipe(effect_1.Schema.brand('@fixtuur/gavel/PartName'));
exports.PropertyName = effect_1.Schema.String;
exports.PropertyValue = effect_1.Schema.Union(effect_1.Schema.String, effect_1.Schema.Number, effect_1.Schema.Null);
exports.PropertySelections = effect_1.Schema.Record({ key: exports.PropertyName, value: exports.PropertyValue });
exports.FilterMode = effect_1.Schema.Literal('standard', 'simple');
exports.PropertyOptions = effect_1.Schema.Record({
    key: exports.PropertyName,
    value: effect_1.Schema.Array(exports.PropertyValue),
});
exports.Cursor = effect_1.Schema.String.pipe(effect_1.Schema.brand('@fixtuur/gavel/Cursor'));
exports.Part = effect_1.Schema.Struct({
    name: exports.PartName,
    hero: effect_1.Schema.Boolean.pipe(effect_1.Schema.optional),
    cardinality: effect_1.Schema.Array(effect_1.Schema.Number),
});
exports.Structure = effect_1.Schema.Struct({
    parts: effect_1.Schema.Array(exports.Part),
});
exports.Configuration = effect_1.Schema.Struct({
    template: exports.TemplateId,
    type: effect_1.Schema.String,
    structure: exports.Structure,
    parts: effect_1.Schema.Array(exports.ParticleId).pipe(effect_1.Schema.annotations({
        description: 'A list of particles corresponding to the parts described in the Structure. In the same order as the parts listing',
    })),
});
exports.PrologRuleId = effect_1.Schema.String.pipe(effect_1.Schema.brand('@fixtuur/gavel/PrologRule/Id'));
exports.PrologRuleBody = effect_1.Schema.String.pipe(effect_1.Schema.brand('@fixtuur/gavel/PrologRule/Body'));
exports.PrologRuleReference = effect_1.Schema.Struct({
    prolog: exports.PrologRuleId,
});
exports.MatchRules = effect_1.Schema.Struct({
    match: effect_1.Schema.Array(effect_1.Schema.Struct({
        includeParticles: effect_1.Schema.Array(exports.ParticleId),
    })),
});
exports.ParticleProperties = effect_1.Schema.Record({
    key: effect_1.Schema.String,
    value: effect_1.Schema.Union(effect_1.Schema.Null, effect_1.Schema.String, effect_1.Schema.Number),
});
exports.Template = effect_1.Schema.Struct({
    rules: effect_1.Schema.Union(exports.PrologRuleReference, exports.MatchRules),
    type: effect_1.Schema.String.pipe(effect_1.Schema.annotations({ description: 'The furniture type constructed by this Template' })),
    structure: exports.Structure,
    properties: effect_1.Schema.Union(effect_1.Schema.Null, exports.ParticleProperties).pipe(effect_1.Schema.optional),
});
exports.TemplateWithId = effect_1.Schema.Tuple(exports.TemplateId, exports.Template);
exports.SpaceId = effect_1.Schema.String.pipe(effect_1.Schema.brand('@fixtuur/gavel/SpaceId'));
exports.ConfigurationSpace = effect_1.Schema.Struct({
    name: effect_1.Schema.optional(effect_1.Schema.String),
    templates: effect_1.Schema.Array(exports.TemplateId),
});
